import { useAuthentication } from 'root/src/client/v2/auth/hooks/useAuthentication';
import { getInheritedGroups } from 'root/src/shared/util/getInheritedGroups';
export function useGroups() {
    const { authentication } = useAuthentication();
    const groups = getInheritedGroups(authentication === null || authentication === void 0 ? void 0 : authentication.groups);
    return {
        groups,
    };
}
